<template>
  <app-modal
    titulo="Confirmar Parceria"
    :width="width"
    :closeOutside="true"
    @closeModal="$emit('closeModal')"
  >
    <template slot="body">
      <div>
        <div class="border-gray border-radius-5px min-h-50px pdd-10px">
          <span>{{ texto }}</span>
        </div>
        <div class="flex-row gap-1 mt-15px">
          <i class="far fa-info-circle color-gray"></i>
          <div class="mt-sub-7px">
            <i class="font-size-12px color-gray">
              Se você clicar em "Não", os dados ficarão disponíveis apenas para a sua visualização,
              e a outra parte não terá mais acesso a eles.
            </i>
          </div>
        </div>
      </div>
    </template>
    <template slot="footer">
      <div class="flex-between">
        <el-button class="w-48-per" @click="() => confirmarParceria(false)">
          <span>Não</span>
        </el-button>
        <el-button class="w-48-per" @click="() => confirmarParceria(true)">
          <span>Sim</span>
        </el-button>
      </div>
    </template>
  </app-modal>
</template>

<script>
import AppModal from '@/components/AppModal'
import AppNotificacao from '@/components/mixins/AppNotificacao.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    AppModal
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
    }
  },

  props: {
    width: {
      type: Number,
      default: 525
    },
    protocolo: {
      type: String,
      required: true
    },
    texto: {
      type: String,
      required: true
    }
  },

  methods: {
    ...mapActions({
      responderVinculo: 'cadastro/responderVinculo'
    }),
    async confirmarParceria (isAceito) {
      await this.responderVinculo({
        protocolo: this.protocolo,
        isAceito: isAceito
      })
      this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, `Parceria ${isAceito ? 'aceita' : 'recusada'} com sucesso.`)
      this.$emit('closeModal')
      this.$emit('atualizarListagem')
    }
  }
}
</script>

<style scoped lang="scss">
  @import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/ConfirmacaoParceria/ConfirmacaoParceria.vue